export default "__VITE_ASSET__C8W6jMvv__"